import vLanguageSelector from "./v-language-selector.vue";

export default Vue => {
  Vue.component("v-language-selector", vLanguageSelector);
};
